var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKuriosLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1131 300",
    style: {
      enableBackground: "new 0 0 1131 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "116.8,176.8 196,89.6 128,89.6 54,173.6 54,0 0,0 0,296 54,296 54,245.6 54,245.6 54,245.5  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.6,208.8c0,25.2-18,42-42.8,42c-25.2,0-42.8-16.8-42.8-42V89.6h-54v119.2c0,54.4,40.4,91.2,96.8,91.2 c56,0,96.8-36.8,96.8-91.2V89.6h-54V208.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.1,143.2V89.6h-54V296h54V180.4c0-35.6,33.6-55.6,77.2-40.4V88.8C557.9,79.2,525.1,89.6,511.1,143.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.1,0c-18,0-32.8,14.4-32.8,32.4c0,17.6,14.8,32.4,32.8,32.4c17.6,0,32.4-14.8,32.4-32.4C680.5,14.4,665.7,0,648.1,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.9,
    y: 89.6,
    width: 54,
    height: 206.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M817.8,85.6c-62.8,0-110.4,46.4-110.4,107.2c0,60.8,47.6,107.2,110.4,107.2c62.8,0,110.4-46.4,110.4-107.2 C928.2,132,880.6,85.6,817.8,85.6z M817.8,250.8c-30.8,0-54.4-24.8-54.4-58c0-32.8,23.6-57.6,54.4-57.6c31.2,0,54.4,24.8,54.4,57.6 C872.2,226,849,250.8,817.8,250.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.8,148.4c0-12,13.2-20,30.4-20c19.2,0,31.6,9.2,34.4,28l53.6-11.2c-6-36-38.8-59.6-88-59.6c-48.4,0-84.8,28-84.8,65.2 c0,82.4,121.2,46,121.2,84.8c0,12-14,21.6-36.4,21.6c-21.2,0-34.4-9.2-36.8-28l-54,11.2c6,36,39.6,59.6,90.8,59.6 c50.4,0,90.8-28,90.8-65.2C1131,151.2,1009.8,187.6,1009.8,148.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.6,233.4 141.6,296 209.6,296 129.4,193.1  "
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuriosLogo);
export default __webpack_public_path__ + "static/media/Kurios-logo.64e02371007aba99b78b8e08cdbcc9d9.svg";
export { ForwardRef as ReactComponent };